import { uniqueId } from 'lodash-es';

let lockKey = null; // 用於追蹤首次 body scroll lock
let bodyScrollTopOnLock;
const syncDocumentHeight = () => {
  document.documentElement.style.height = `${window.innerHeight}px`;
};

function lockBodyScroll() {
  bodyScrollTopOnLock =
    window.pageYOffset ||
    document.documentElement.scrollTop ||
    document.body.scrollTop ||
    0;
  document.body.style.overflow = 'hidden';
  document.body.style.position = 'fixed';
  document.body.style.top = `${-bodyScrollTopOnLock}px`;
  document.body.style.bottom = '0';
  document.body.style.left = '0';
  document.body.style.right = '0';
  syncDocumentHeight();
  window.addEventListener('resize', syncDocumentHeight);
}

/**
 * 利用 position fixed 將 body 的畫面固定在當前 scroll 的位置，解鎖時再將 scroll 的位置重新設回 window （參考 Airbnb modal 的做法）
 *
 * @return {string} 供 unlock 時識別是否具有權限的 key
 *
 * @example
 * const lockKey = kkLockBodyScroll();
 */
export function kkLockBodyScroll() {
  if (lockKey) {
    return uniqueId();
  }
  lockBodyScroll();
  lockKey = uniqueId();
  return lockKey;
}

function unlockBodyScroll() {
  window.removeEventListener('resize', syncDocumentHeight);
  document.body.style.overflow = '';
  document.body.style.position = '';
  document.body.style.top = '';
  document.body.style.bottom = '';
  document.body.style.left = '';
  document.body.style.right = '';
  document.documentElement.style.height = '';
  document.documentElement.style.scrollBehavior = 'auto'; // avoid CSS scroll-behavior `smooth` transition
  window.scrollTo(0, bodyScrollTopOnLock);
  document.documentElement.style.scrollBehavior = '';
}

/**
 * 解鎖 body scroll
 *
 * @param {string=} key - 判斷是否可以 unlock 的 key（無 key 時直接 unlock）
 *
 * @example
 * // 傳入 lockKey 判斷
 * const lockKey = kkLockBodyScroll();
 * kkUnlockBodyScroll(lockKey);
 *
 * // 直接 unlock
 * kkUnlockBodyScroll();
 */
export function kkUnlockBodyScroll(key) {
  if (key && lockKey !== key) {
    return;
  }
  unlockBodyScroll();
  lockKey = null;
}

/**
 * Reference
 * - https://css-tricks.com/prevent-page-scrolling-when-a-modal-is-open/
 */

/**
 * 檢查 body scroll lock 的狀態
 *
 * @return {boolean} 是否為 locked 狀態
 *
 * @example
 * const isBodyScrollLocked = kkCheckIsBodyScrollLocked();
 */
export function kkCheckIsBodyScrollLocked() {
  return lockKey !== null;
}
